module.exports = {"donut":{"chart":{"type":"pieChart","height":210,"showLabels":false,"donut":true,"donutRatio":1.25,"showLegend":false,"growOnHover":false,"tooltip":{"enabled":true,"classes":"my-price-point-mix-tooltip"}},"noData":"","xAxis":{"showMaxMin":false}}}


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/dashboard-widget/my-price-point-mix/my-price-point-mix-chart.conf.json
// module id = 1633
// module chunks = 0